//Componentes Generales
import React from "react";
import Rutas from "./utils/Rutas/Rutas";

//Contexto
import AuthState from "./context/authentication/authState";
import UsuariosState from "./context/usuarios/usuariosState";
import ProdutosState from "./context/productos/productsState";
import ControlState from "./context/control/controlState";
import ControlGLBState from "./context/controlGLB/controlGLBState";
import AgregarReqState from "./context/agregarReq/agregarReqState";
import GruposState from "./context/grupos/gruposState";
import ProveedoresState from "./context/proveedores/proveedoresState";
import DistribucionesState from "./context/distribuciones/distribucionesState";
import WindowSizeState from "./context/windowSize/windowSizeState";

//Socket
import Socket from "./context/socket/socket";

import "./Styles.css";

function App() {
  return (
    <div className="App">
      <Socket>
        <AuthState>
          <ControlState>
            <ControlGLBState>
              <AgregarReqState>
                      <ProveedoresState>
                        <DistribucionesState>
                          <GruposState>
                            <UsuariosState>
                              <ProdutosState>
                                <WindowSizeState>
                                  <Rutas />
                                </WindowSizeState>
                              </ProdutosState>
                            </UsuariosState>
                          </GruposState>
                        </DistribucionesState>
                      </ProveedoresState>
              </AgregarReqState>
            </ControlGLBState>
          </ControlState>
        </AuthState>
      </Socket>
    </div>
  );
}

export default App;